export const SIDEBAR_W = 272;

export const CHAT_MAX_W = 860;
export const COMPOSER_MAX_W = 860;

export const LANG = {
  newChat: "New Chat",
  searchConversations: "Search conversations...",
  typeMessage: "Message...",
  send: "Send",
  deleteConversation: "Delete conversation",
  renameConversation: "Rename",
  confirmDelete: "Delete this conversation? This cannot be undone.",
  delete: "Delete",
  cancel: "Cancel",
  rename: "Rename",
  newTitle: "New title",
  copy: "Copy",
  copied: "Copied!",
  webAccess: "Web Access",
  selectModel: "Select Model",
  noConversations: "No conversations yet",
  startNewChat: "Start a new chat",
  thinking: "Thinking...",
  errorOccurred: "Something went wrong. Please try again.",
  conversations: "Conversations",
  models: "Models",
  today: "Today",
  yesterday: "Yesterday",
  older: "Older",
};
